var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from "react";
import ModalDialog, { ModalTransition } from '@atlaskit/modal-dialog';
import { compose, Field, getErrorMessage, withMountTracking, } from "@atlassiansox/microscopekit";
import Button from '@atlaskit/button';
import styled from "styled-components";
import CrossIcon from '@atlaskit/icon/glyph/cross';
import { InlineEditableTextfield } from '@atlaskit/inline-edit';
import { SimpleTag } from "@atlaskit/tag";
import { ExemptAction, useCredoExemptionDispatch, useCredoExemptionState } from "../../../credo-exemption-context";
import CredoExemptionUtils, { CredoExemptionTicketLink } from "../../util/credo-exemption-utils";
import { CredoExemptionView, ExemptionSuccessMessageComponent } from "./credo-exemption";
import { gridSize as getGridSize } from '@atlaskit/theme/constants';
var TagGroup = require('@atlaskit/tag-group').default;
var WarningIcon = require("@atlaskit/icon/glyph/warning").default;
var gridSize = getGridSize();
var WarningInfoIcon = styled(WarningIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  vertical-align: middle;\n  fill: red;\n"], ["\n  vertical-align: middle;\n  fill: red;\n"])));
var InfoDiv = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: #dfe1e6;\n  border-color: #dfe1e6;\n  border-radius: 5px;\n  border-style: solid;\n  box-sizing: border-box;\n  font-size: 12px;\n  max-width: 100%;\n  overflow: hidden;\n  border-width: 1px;\n  padding: 5px;\n  font-weight: 300;\n  margin-bottom: 10px;\n  span {\n    vertical-align: middle;\n    padding: 2px;\n    fill: red;\n    color: red;\n  }\n"], ["\n  background-color: #dfe1e6;\n  border-color: #dfe1e6;\n  border-radius: 5px;\n  border-style: solid;\n  box-sizing: border-box;\n  font-size: 12px;\n  max-width: 100%;\n  overflow: hidden;\n  border-width: 1px;\n  padding: 5px;\n  font-weight: 300;\n  margin-bottom: 10px;\n  span {\n    vertical-align: middle;\n    padding: 2px;\n    fill: red;\n    color: red;\n  }\n"])));
var Container = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: '40px 44px 36px',\n  textAlign: 'center',\n  > * {\n    padding-bottom: 15px;\n  }\n"], ["\n  padding: '40px 44px 36px',\n  textAlign: 'center',\n  > * {\n    padding-bottom: 15px;\n  }\n"])));
var NewExemptionContainer = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding: '40px 44px 36px',\n  textAlign: 'center',\n  > :last-child {\n    padding-bottom: 15px;\n    margin-bottom: 40px\n  }\n"], ["\n  padding: '40px 44px 36px',\n  textAlign: 'center',\n  > :last-child {\n    padding-bottom: 15px;\n    margin-bottom: 40px\n  }\n"])));
var CredoExemptionViewMainContainer = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  padding: '40px 44px 36px',\n  textAlign: 'center',\n  margin-bottom: 40px;\n  > :last-child {\n    margin-bottom: 40px;\n  }\n"], ["\n  padding: '40px 44px 36px',\n  textAlign: 'center',\n  margin-bottom: 40px;\n  > :last-child {\n    margin-bottom: 40px;\n  }\n"])));
var HeaderContainer = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 24px;\n  padding-bottom: 10px;\n  letterSpacing: '-0.008em',\n  lineHeight: 1.2,\n  > :nth-child(2) {\n    cursor: pointer;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 24px;\n  padding-bottom: 10px;\n  letterSpacing: '-0.008em',\n  lineHeight: 1.2,\n  > :nth-child(2) {\n    cursor: pointer;\n  }\n"])));
var ButtonContainer = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-center;\n  padding-top: 10px\n  margin-bottom: 20px;\n  margin-top: 20px;\n  padding-left: 150px;\n  > :first-child {\n    margin-right: 20px;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-center;\n  padding-top: 10px\n  margin-bottom: 20px;\n  margin-top: 20px;\n  padding-left: 150px;\n  > :first-child {\n    margin-right: 20px;\n  }\n"])));
var ServiceMetaContainer = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  display: flex;\n  padding: 10px 10px 10px 0px;\n  gap: 24\n  flex-direction: column;\n  margin-bottom: 10px;\n  padding-bottom: 0px;\n"], ["\n  display: flex;\n  padding: 10px 10px 10px 0px;\n  gap: 24\n  flex-direction: column;\n  margin-bottom: 10px;\n  padding-bottom: 0px;\n"])));
var ModalHeader = function (_a) {
    var title = _a.title, onClose = _a.onClose;
    return (React.createElement(HeaderContainer, null,
        React.createElement("h3", null, title),
        onClose ? React.createElement("div", null,
            React.createElement(CrossIcon, { size: "small", label: "close", onClick: onClose })) : undefined));
};
var CredoExemptionViewContainer = function (_a) {
    var onClose = _a.onClose, cancelExemptionDef = _a.cancelExemptionDef, isLoading = _a.isLoading;
    var state = useCredoExemptionState();
    var dispatch = useCredoExemptionDispatch();
    return (React.createElement(CredoExemptionViewMainContainer, null, state.metaData.isHistoryAvailable && state.credoExemptionData && state.credoExemptionData.length ?
        [state.credoExemptionData.map(function (exemption) {
                var _possibleAction = CredoExemptionUtils.getPossibleAction(exemption, state.tier);
                var _possibleActionDef = cancelExemptionDef;
                // Only supports cancel exemption from list exemption view
                if (!_possibleAction || _possibleAction.name !== ExemptAction.CANCEL) {
                    _possibleAction = null;
                    _possibleActionDef = function dummy(ticket) {
                        // Do nothing
                    };
                }
                return (React.createElement(CredoExemptionView, { key: "exemption-" + exemption.key, credoExemptionData: exemption, isLoading: isLoading, onClose: onClose, actionLabel: _possibleAction, credoExemptionDef: _possibleActionDef }));
            })]
        : "No exemption data found."));
};
var CredoExemption = function (_a) {
    var onClose = _a.onClose, createExemptionDef = _a.createExemptionDef, isLoading = _a.isLoading, user = _a.user;
    var state = useCredoExemptionState();
    var dispatch = useCredoExemptionDispatch();
    return (React.createElement(NewExemptionContainer, null,
        React.createElement(InfoDiv, null,
            React.createElement("div", null,
                React.createElement(WarningInfoIcon, { label: "Warning", secondaryColor: "#DFE1E6", size: "medium" }),
                React.createElement("span", null, "Exempting the operation readiness a.k.a Credo review is highly discouraged! This option should be exercised only in the extreme scenarios with the appropriate justification. Exemption will be granted upon the approval of your Head of Engineering."))),
        React.createElement(Container, null,
            React.createElement(ServiceMetaContainer, null,
                React.createElement(Field, { name: 'exemptionServiceMetaData', label: 'Service Details' }, function () { return (React.createElement("div", { style: {
                        padding: gridSize + "px " + gridSize + "px " + gridSize * 2 + "px",
                    } },
                    React.createElement(TagGroup, null,
                        React.createElement(SimpleTag, { text: 'Tier: ' + state.tier, appearance: 'rounded' }),
                        state.soc2 && React.createElement(SimpleTag, { text: state.soc2 ? 'SOC2' : '', appearance: 'rounded' }),
                        state.extendFromTicket && React.createElement(SimpleTag, { text: 'Extends: ' + state.extendFromTicket, href: "" + CredoExemptionTicketLink + state.extendFromTicket, appearance: 'rounded' })))); })),
            React.createElement(Field, { name: 'exemptionJustification', label: 'Justify', isRequired: true }, function () { return (React.createElement("div", { style: {
                    padding: "0px " + gridSize + "px " + gridSize * 2 + "px",
                } },
                React.createElement(InlineEditableTextfield, { defaultValue: state.justification, onConfirm: function (value) { return dispatch({ type: 'setJustification', data: { value: value } }); }, placeholder: "Please provide the justification as to why you can't do the Credo review at the moment. And also the timeline after which you are able to do the Credo review for your service.", isCompact: true }))); })),
        React.createElement("hr", null),
        React.createElement(ButtonContainer, null,
            React.createElement(Button, { appearance: "primary", isLoading: isLoading, isDisabled: isLoading, onClick: function () {
                    if (state.justification.length <= 0) {
                        return;
                    }
                    createExemptionDef(user);
                } }, "Request Exemption"),
            React.createElement(Button, { appearance: "default", isLoading: isLoading, onClick: function () { return onClose(); } }, "Cancel"))));
};
var CredoExemptionModalView = function (_a) {
    var createCredoExemption = _a.createCredoExemption, cancelCredoExemption = _a.cancelCredoExemption, track = _a.track, history = _a.history, user = _a.user, showFlag = _a.showFlag;
    var _b = useState({ loading: false }), credoExemptionModal = _b[0], setCredoExemptionModal = _b[1];
    var state = useCredoExemptionState();
    var dispatch = useCredoExemptionDispatch();
    var onCLoseWrapper = function () {
        setCredoExemptionModal(__assign(__assign({}, credoExemptionModal), { loading: false }));
        dispatch({ type: "setOpen", data: { value: false } });
    };
    var createCredoExemptionAction = function (user) { return __awaiter(void 0, void 0, void 0, function () {
        var _userName, response, _exemption, _status, _ticket_key, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setCredoExemptionModal(__assign(__assign({}, credoExemptionModal), { loading: true }));
                    track("Credo.StartCredoExemption: Started", {
                        category: "info",
                    });
                    setCredoExemptionModal(__assign(__assign({}, credoExemptionModal), { loading: true }));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    _userName = user ? user.username : '';
                    return [4 /*yield*/, createCredoExemption({
                            variables: {
                                input: {
                                    creator: _userName,
                                    justification: state.justification,
                                    tier: state.tier,
                                    soc2: state.soc2,
                                    extendsFrom: state.extendFromTicket,
                                    serviceName: state.serviceId,
                                }
                            },
                        })];
                case 2:
                    response = _a.sent();
                    _exemption = (response && response.data) ? response.data.createCredoExemption : undefined;
                    _status = (_exemption) ? _exemption.status : undefined;
                    if (!_status) {
                        throw new Error("Failed to create credo exemption: ");
                    }
                    track("Credo.StartCredoExemption: Succeeded", {
                        category: "info",
                    });
                    _ticket_key = (response && response.data && response.data.createCredoExemption) ?
                        response.data.createCredoExemption.key : '';
                    showFlag({
                        type: "success",
                        title: "Credo Exemption.",
                        message: React.createElement(ExemptionSuccessMessageComponent, { ticketKey: _ticket_key, message: "New Exemption request has been created." }),
                    });
                    dispatch({ type: 'setCredoExemptionData', data: { value: _exemption } });
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    track("Credo.StartCredoExemption: Failed", {
                        category: "error",
                    });
                    showFlag({
                        type: "error",
                        title: "Failed to create credo exemption.",
                        message: getErrorMessage(error_1),
                    });
                    return [3 /*break*/, 5];
                case 4:
                    setCredoExemptionModal(__assign(__assign({}, credoExemptionModal), { loading: false }));
                    dispatch({ type: 'setOpen', data: { value: false } });
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var cancelCredoExemptionAction = function (ticket) { return __awaiter(void 0, void 0, void 0, function () {
        var response, _exemption, _status, _ticket_key, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    track("Credo.CancelCredoExemption: Started", {
                        category: "info",
                    });
                    setCredoExemptionModal(__assign(__assign({}, credoExemptionModal), { loading: true }));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, cancelCredoExemption({
                            variables: {
                                ticketId: ticket
                            },
                        })];
                case 2:
                    response = _a.sent();
                    _exemption = (response && response.data) ? response.data.cancelCredoExemption : undefined;
                    _status = (_exemption) ? _exemption.status : undefined;
                    if (!_status) {
                        throw new Error("Failed to cancel credo exemption: " + ticket);
                    }
                    track("Credo.CancelCredoExemption: Succeeded", {
                        category: "info",
                    });
                    _ticket_key = (response && response.data && response.data.cancelCredoExemption) ?
                        response.data.cancelCredoExemption.key : '';
                    showFlag({
                        type: "success",
                        title: "Credo Exemption.",
                        message: React.createElement(ExemptionSuccessMessageComponent, { ticketKey: _ticket_key, message: "Exemption request has been cancelled." }),
                    });
                    dispatch({ type: 'setCredoExemptionData', data: { value: _exemption } });
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _a.sent();
                    track("Credo.CancelCredoExemption: Failed", {
                        category: "error",
                    });
                    showFlag({
                        type: "error",
                        title: "Failed to cancel credo exemption.",
                        message: getErrorMessage(error_2),
                    });
                    return [3 /*break*/, 5];
                case 4:
                    setCredoExemptionModal(__assign(__assign({}, credoExemptionModal), { loading: false }));
                    dispatch({ type: 'setOpen', data: { value: false } });
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    // Order of the array matters a lot. Please be cautious while adding new element.
    var pages = [
        { title: 'Request for exemption', content: React.createElement(CredoExemption, { onClose: onCLoseWrapper, createExemptionDef: createCredoExemptionAction, isLoading: credoExemptionModal.loading, user: user }), hideClose: false },
        { title: 'Exemption history', content: React.createElement(CredoExemptionViewContainer, { onClose: onCLoseWrapper, cancelExemptionDef: cancelCredoExemptionAction, isLoading: credoExemptionModal.loading }), hideClose: false },
    ];
    return (React.createElement(ModalTransition, null, state.isOpen &&
        React.createElement(ModalDialog, { onClose: function () { return onCLoseWrapper(); }, shouldCloseOnOverlayClick: false, components: {
                Header: pages[state.page].title ? function () {
                    return React.createElement(ModalHeader, { title: pages[state.page].title, onClose: function () { return !pages[state.page].hideClose ? onCLoseWrapper() : undefined; } });
                } : undefined,
            } }, pages[state.page].content)));
};
var CredoExemptionModal = compose(withMountTracking('Credo.CredoExemptionModal'))(CredoExemptionModalView);
export default CredoExemptionModal;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
